module.exports = __webpack_public_path__ + "assets/573d2e035862bcb94f64191527673d1c.png";